import { IApplicationState } from '../../types/redux';
import { getReviewById } from './getReviewById';

export const getIsReviewAuthorAnonymousById =
  (id: string) =>
  (state: IApplicationState): boolean => {
    const review = getReviewById(id)(state);

    return review?.isAnonymous || false;
  };
